// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"505064f0","427":"57cabf46","463":"bc16e458","751":"911e3933","945":"ed3e4690"}[chunkId] + ".chunk.css";
};